export const getTitleForTimer = (timerType: string) => {
  if (timerType === 'untilEnd') {
    return 'До конца акции';
  }
  if (timerType === 'untilStart') {
    return 'До начала акции';
  }
  if (timerType === 'untilNearest' || timerType === 'manual') {
    return 'До события';
  }
  return null;
};
